import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  forwardRef,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  AlertController,
  IonicModule,
  ModalController,
  NavParams,
  ToastController,
} from "@ionic/angular";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { ImagePipe } from "src/app/pipes/image/image";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { PhoneIntlDirective } from "src/app/directive/phone-intl-directive/phone-intl.directive";
import { NgxMaskDirective } from "ngx-mask";
@Component({
  selector: "app-recadastro-pessoa",
  templateUrl: "./recadastro-pessoa.page.html",
  styleUrls: ["./recadastro-pessoa.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    ReactiveFormsModule,
    ProverDatepickerComponent,
    DateFormatPipe,
    PhoneIntlDirective,
    NgxMaskDirective,
  ],
})
export class RecadastroPessoaPage implements OnInit {
  pessoa: any;
  tipo: any;
  dados: boolean = false;
  editando: boolean = false;
  validations_form!: FormGroup;
  maskMap = new Map<string, string>();
  statusList: any = [
    { id: "6", nome: "QUER O APLICATIVO" },
    { id: "1", nome: "NÃO QUER O APLICATIVO" },
    { id: "4", nome: "NÃO LOCALIZADO" },
    { id: "2", nome: "FALECIDO" },
    { id: "3", nome: "AFASTADO" },
    { id: "5", nome: "RECUSOU-SE A ATUALIZAR" },
  ];
  formSubmitted = false;

  validation_messages = {
    nome: [
      {
        type: "required",
        message: this.translate.instant("Campo Obrigatório"),
      },
    ],
    nascimento: [
      {
        type: "required",
        message: this.translate.instant("Campo Obrigatório"),
      },
    ],
    email: [
      {
        type: "required",
        message: this.translate.instant("Campo Obrigatório"),
      },
    ],
    cpf: [
      {
        type: "required",
        message: this.translate.instant("Campo Obrigatório"),
      },
    ],
    telCelular: [
      {
        type: "required",
        message: this.translate.instant("Campo Obrigatório"),
      },
    ],
  };

  constructor(
    public modalCtrl: ModalController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private pessoaProvider: PessoaProvider,
    private translate: TranslateService,
    public toastCtrl: ToastController,
    private alertController: AlertController
  ) {
    this.pessoa = this.navParams.get("pessoa");
    if (this.pessoa.cpf === "00000000000") {
      this.pessoa.cpf = "";
    }

    this.tipo = this.pessoa
      ? this.pessoa.codigo2 !== null
        ? this.pessoa.codigo2
        : ""
      : "";
    this.initializeForm(this.tipo);
  }

  ngOnInit() {}

  changeStatus(event: { detail: { value: any } }) {
    this.tipo = event.detail.value;
    if (this.tipo == "6") {
      const controls = ["nome", "nascimento", "email", "cpf", "telCelular"];

      controls.forEach((ctrl) => {
        const control = this.validations_form.get(ctrl);
        if (control) {
          control.setValidators([Validators.required]);
          control.updateValueAndValidity();
          control.markAsPristine();
          control.markAsUntouched();
        }
      });
    } else if (this.tipo == "1") {
      this.validations_form.get("nome")?.setValidators([Validators.required]);
      this.validations_form.controls["nome"].updateValueAndValidity();
      this.validations_form
        .get("nascimento")
        ?.setValidators([Validators.required]);
      this.validations_form.controls["nascimento"].updateValueAndValidity();
      this.validations_form
        .get("email")
        ?.setValidators([Validators.nullValidator]);
      this.validations_form.controls["email"].updateValueAndValidity();
      this.validations_form
        .get("cpf")
        ?.setValidators([Validators.nullValidator]);
      this.validations_form.controls["cpf"].updateValueAndValidity();
      this.validations_form
        .get("telCelular")
        ?.setValidators([Validators.nullValidator]);
      this.validations_form.controls["telCelular"].updateValueAndValidity();
    } else {
      this.validations_form
        .get("nome")
        ?.setValidators([Validators.nullValidator]);
      this.validations_form.controls["nome"].updateValueAndValidity();
      this.validations_form
        .get("nascimento")
        ?.setValidators([Validators.nullValidator]);
      this.validations_form.controls["nascimento"].updateValueAndValidity();
      this.validations_form
        .get("email")
        ?.setValidators([Validators.nullValidator]);
      this.validations_form.controls["email"].updateValueAndValidity();
      this.validations_form
        .get("cpf")
        ?.setValidators([Validators.nullValidator]);
      this.validations_form.controls["cpf"].updateValueAndValidity();
      this.validations_form
        .get("telCelular")
        ?.setValidators([Validators.nullValidator]);
      this.validations_form.controls["telCelular"].updateValueAndValidity();
    }

    this.validations_form
      .get("codigo2")
      ?.setValidators([Validators.nullValidator]);
    this.validations_form.controls["codigo2"].updateValueAndValidity();
  }

  initializeForm(tipo: string) {
    this.validations_form = this.formBuilder.group({
      nome: new FormControl(
        this.pessoa.nome,
        tipo === "6" || tipo === "1"
          ? Validators.required
          : Validators.nullValidator
      ),
      nascimento: new FormControl(
        this.pessoa.nascimento,
        tipo === "6" || tipo === "1"
          ? Validators.required
          : Validators.nullValidator
      ),
      email: new FormControl(
        this.pessoa.contato?.email,
        tipo === "6" ? Validators.required : Validators.nullValidator
      ),
      cpf: new FormControl(
        this.pessoa.cpf || "",
        tipo === "6" ? Validators.required : Validators.nullValidator
      ),
      telCelular: new FormControl(
        this.pessoa.contato?.telCelular || "",
        tipo === "6" ? Validators.required : Validators.nullValidator
      ),
      codigo2: new FormControl(this.pessoa.codigo2 || ""),
    });
  }

  salvarTodos() {
    if (!this.validations_form.valid) {
      this.camposAlert();
    } else {
      if (this.validations_form.value.email === "") {
        this.emailAlert();
      } else {
        this.validateAllFormFields(this.validations_form);
        if (this.validations_form.valid) {
          this.salvarRecadastramento();
        }
      }
    }
  }

  salvar() {
    if (!this.validations_form.valid) {
      this.camposAlert();
    }

    this.validateAllFormFields(this.validations_form);

    if (this.validations_form.valid) {
      this.salvarRecadastramento();
    }
  }

  async salvarRecadastramento() {
    if (this.validations_form.value.codigo2 === "") {
      this.camposAlert();
    } else {
      this.pessoaProvider
        .salvarRecadastramento(
          this.validations_form.value,
          this.pessoa.id,
          this.tipo
        )
        .subscribe(async (pessoa) => {
          if (pessoa.error && pessoa.message) {
            const alert = await this.alertController.create({
              header: "Ops",
              subHeader: "Erro ao salvar cadastro",
              message: pessoa.message
                ? pessoa.message
                : "Erro ao salvar a atualização de cadastro",
              buttons: ["OK"],
            });

            alert.present();
          } else {
            let alert = await this.alertController.create({
              message: this.translate.instant(
                "Atualização Cadastral salva com sucesso!"
              ),
              buttons: [
                {
                  text: this.translate.instant("Ok"),
                  handler: () => {
                    this.modalCtrl.dismiss({ recadastro: true });
                  },
                },
              ],
            });
            alert.present();
          }
        });
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  async emailAlert() {
    const alert = await this.alertController.create({
      header: "Ops",
      subHeader: "E-mail Inválido!",
      message: "Adicione um E-mail valido",
      buttons: ["OK"],
    });

    await alert.present();
  }

  async camposAlert() {
    const alert = await this.alertController.create({
      header: "Ops",
      subHeader: "Verifique se todos os campos foram preenchidos!",
      buttons: ["OK"],
    });

    await alert.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }
}
